import { useState } from 'react';
import { textToImage, textToImageStatus } from "@/api/apiMethods.js";
import { imgToVideo, imgToVideoStatus } from "@/api/apiMethods.js";

function Aivideo() {
    // 文生图功能区
    const [description, setDescription] = useState('');  // 用户输入文生图描述
    const [videoDescription, setVideoDescription] = useState('');  // 用户输入视频描述

    const [enhancePrompt, setEnhancePrompt] = useState('yes');
    const [enhanceStyle, setEnhanceStyle] = useState('game-cyberpunk');
    const [imgSeed, setImgSeed] = useState(-1);
    const [guidanceScale, setGuidanceScale] = useState(10);
    const [tomesd, setTomesd] = useState('yes');
    const [useKarrasSigmas, setUseKarrasSigmas] = useState('yes');
    const [ImgVae, setImgVae] = useState('');
    const [loraStrength, setLoraStrength] = useState('');
    const [loraModel, setLoraModel] = useState('');
    const [selfAttention, setSelfAttention] = useState('yes');
    const [clipSkip, setClipSkip] = useState(2);
    const [highresFix, setHighresFix] = useState('no');

    const [imageUrl, setImageUrl] = useState('');         // 生成的图片
    const [videoUrl, setVideoUrl] = useState('');
    const [message, setMessage] = useState('');
    const [vmessage, setvMessage] = useState('');
    const [desc, setdesc] = useState('');
    const [isLoading, setIsLoading] = useState(false);    // 加载状态
    const [radioStates, setRadioStates] = useState({
        EnhancePrompt: 'yes',   // 默认值
        tomesd: 'yes',
        useKarrasSigmas: 'yes',
        selfAttention: 'yes',   // 默认值
        highresFix: 'no',
    });

    const handleInputChange = (e) => {
        setDescription(e.target.value);
        setMessage('');
    };

    const handleVideoInputChange = (e) => {
        setVideoDescription(e.target.value);
        setvMessage('');
    };

    // 生成图片
    const handleGenerateImage = async () => {
        if (!description) {
            setMessage('The input cannot be empty, please enter a description of the picture');
            return;
        }
        setIsLoading(true);
        try {
            const res = await textToImage({
                prompt: `masterpiece,best quality,realistic,photorealistic)), Super scene description, a cyber ${description} roaming in the future neon technology cyberpunk style city at night, wearing high-tech armor, blue and purple color technology ${description} form, wearing technology virtual VR glasses, a huge blue and purple gradient technology neon city background,`,
            });
            setdesc(res);
            const intervalId = setInterval(async () => {
                const resStatus = await textToImageStatus({ fetch_id: res.id });
                if (resStatus.status === 'success') {
                    clearInterval(intervalId);
                    setImageUrl(resStatus.output[0]);
                    setIsLoading(false);
                } else {
                    setMessage(resStatus.msg);
                }

                console.log(res, resStatus);
            }, 5000);
        } catch (error) {
            console.error('Error occurred:', error);
            setIsLoading(false);
        }
    };



    // 生成视频
    const handleGenerateVideo = async () => {
        // if (!videoDescription) {
        //     setvMessage('The input cannot be empty, please enter a description of the picture');
        //     return;
        // }
        setIsLoading(true);
        try {
            const response = await imgToVideo({
                promptImage: imageUrl,  // 图片的 URL
                promptText: videoDescription ? videoDescription : 'The neon lights of the city in the background flicker with light particle effects, and the wind blows through the character, causing the character\'s hair and clothes to flutter.',  // 生成视频时的描述文字
                duration: 5  // 视频持续时间
            });
            console.log(response);
            if (response) {
                const videoInter = setInterval(async () => {
                    const videoStatus = await imgToVideoStatus({
                        id: response.id,
                    });
                    console.log(videoStatus, 'videoStatus');
                    if (videoStatus.status === 'SUCCEEDED') {
                        console.log(videoStatus, 'videoStatus');
                        setVideoUrl(videoStatus.output[0]);
                        clearInterval(videoInter);
                        setIsLoading(false);
                    }
                }, 5000);
            }
        } catch (e) {
            console.log(e.message);
        }
    };

    return (
        <div className="bg-black h-screen text-white flex justify-between p-4">
            <div className="flex-1 px-4">
                <div>
                    <h1 className="text-2xl font-bold mb-4">Image to Video Endpoint</h1>
                    <textarea
                        value={videoDescription}
                        onChange={handleVideoInputChange}
                        placeholder="Input description to generate video"
                        className="w-full p-2 mb-4 text-black rounded"
                        rows="2"
                        cols="50"
                    ></textarea>
                    <p className='text-red-500'>{vmessage}</p>
                </div>

                {/* <button
                    onClick={handleGenerateImage}
                    className="bg-blue-500 px-6 py-2 rounded text-white font-bold mb-4 mt-4"
                    disabled={isLoading}
                >
                    {isLoading ? 'Generating...' : 'Generate video'}
                </button> */}

                <button
                    onClick={handleGenerateVideo}
                    className="bg-blue-500 px-6 py-2 rounded text-white font-bold mb-4 mt-4 ml-3"
                    disabled={isLoading}
                >
                    {isLoading ? 'Generating...' : 'Generate video'}
                </button>

            </div>
            <div className='flex-1 w-[300px] h-[655px] border border-white'>
                <h4 className='text-4xl font-bold mb-4 p-2'>Preview</h4>
                {isLoading && (
                    <div className="flex justify-center mb-4">
                        <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
                    </div>
                )}
                <div className="mb-4 flex items-center justify-between">
                    {imageUrl && !isLoading && (
                        <img
                            src={imageUrl}
                            alt="Generated"
                            className="rounded shadow-lg"
                            style={{ maxWidth: '45%' }}
                        />
                    )}
                    {videoUrl && !isLoading && (
                        <div className="flex-1 ml-3">
                            <video className="w-full" loop autoPlay muted>
                                <source src={videoUrl} type="video/mp4" />
                            </video>
                        </div>
                    )}
                </div>
            </div>
            <div className='flex-1 w-[300px] h-[655px] overflow-auto border border-white ml-3'>
                <h4 className='text-4xl font-bold mb-4 p-2'>result</h4>
                <h4 className='text-4xl font-bold mb-4 p-2'>{ }</h4>
                <div className="bg-black p-4 text-white">
                    <pre>{JSON.stringify({ desc }, null, 2)}</pre>
                </div>
            </div>
        </div>
    );
}

export default Aivideo;
